module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/babel-core/~/core-js/modules/$.property-desc.js
 ** module id = 80
 ** module chunks = 0
 **/